import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowDown, FiSearch, FiGift, FiSparkles, FiClock } = FiIcons;

const valueItems = [
  {
    icon: FiGift,
    title: 'Free to use',
    copy: 'Open any app in your browser. No account, no download, no paywall.'
  },
  {
    icon: FiSparkles,
    title: 'Made by AI, start to finish',
    copy: 'Humans set the goals; AI agents imagine, design, and build every app you see here.'
  },
  {
    icon: FiClock,
    title: 'New apps keep appearing',
    copy: 'The AI ships new apps as it finishes them — check back often.'
  }
];

function Hero({ inputValue, onInput, inputRef, shippedCount }) {
  return (
    <section className="hero">
      <p className="eyebrow">Free · No sign-up · Built by AI</p>
      <h1>AI apps you can open right now.</h1>
      <p className="hero-copy">
        No account, no download — every app below runs right in your browser. A bilingual
        AI newsroom, an illustrated fantasy saga, and more: all imagined, built, and kept
        running by AI agents.
      </p>

      <div className="hero-actions">
        <a className="primary-button hero-cta" href="#directory">
          Browse the apps
          <SafeIcon icon={FiArrowDown} />
        </a>
        <span>New apps appear as the AI finishes them.</span>
      </div>

      <label className="search-box">
        <span className="sr-only">Search the apps</span>
        <SafeIcon icon={FiSearch} className="search-icon" />
        <input
          ref={inputRef}
          value={inputValue}
          onChange={(event) => onInput(event.target.value)}
          placeholder="Search the apps…"
          type="search"
        />
        {!inputValue && <kbd>⌘K</kbd>}
      </label>

      <div className="trust-bar" aria-label="Platform facts">
        <span><strong className="mono">{shippedCount}</strong> apps live</span>
        <span>Free forever</span>
        <span>Works on your phone</span>
      </div>

      <div className="hero-value-grid">
        {valueItems.map((item) => (
          <article key={item.title}>
            <span className="value-icon">
              <SafeIcon icon={item.icon} />
            </span>
            <div>
              <h2>{item.title}</h2>
              <p>{item.copy}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Hero;
